import React, { useEffect } from 'react'
import "./genres.css"
import { Chip } from '@material-ui/core'
import axios from 'axios'


const Genres = ({type, setPage, genres, setGenres, selectedGenres, setSelectedGenres}) => {
  
  useEffect(() => {
    axios.get(`https://api.themoviedb.org/3/genre/movie/list?api_key=${process.env.REACT_APP_API_KEY}&language=en-US`)
      .then(res => {
        // console.log(res.data)
        setGenres(res.data.genres)
      })
      .catch(err => {
        console.log(err)
      })
  }, [])
  
  const addGenre =  (genre) => {
    // console.log(genre)
    // monishnul genre-s chaagdebs selectedGenres-shi da amoagdebs genres-dan
    setSelectedGenres([...selectedGenres, genre])
    setGenres(genres.filter((g) => g.id !== genre.id))
    setPage(1)
  }
  const removeGenre = (genre) => {
    setGenres([...genres, genre])
    setSelectedGenres(selectedGenres.filter((g) => g.id !== genre.id))
  }

  return (
    <div className='genres-container'>
      {selectedGenres && selectedGenres.map((genre, i) => {
        return <div key={i} className="genre-card active"
          onClick={() => removeGenre(genre)}
        >
          <p>{genre.name}</p>
        </div>
        
        // <Chip key={i} label={genre.name} clickable
        //   color="primary" 
        //   style={{margin:2}}
        //   onClick={() => removeGenre(genre)}  
        // />
      })}
      {genres && genres.map((genre, i) => {
        return <div key={i} className="genre-card"
        onClick={() => addGenre(genre)}
      >
        <p>{genre.name}</p>
      </div>
      })}
    </div>
  )
}

export default Genres
